import Vuex from 'vuex'
import Vue from 'vue'
import snackbar from './modules/snackbar'
import pageLoader from './modules/pageLoader'
import userModule from './modules/user'
import itemModule from './modules/items'
import uploadModule from './modules/upload'
import nexrenderModule from './modules/nexrender'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    snackbar,
    pageLoader,
    users: userModule,
    items: itemModule,
    upload: uploadModule,
    nexrender: nexrenderModule,
  },
})
